exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "dt,\r\ndd {\r\n    word-break: break-all;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/styles/account/profileView.component.css
// module id = 440
// module chunks = 0